<template>
    <div>
        <div class="menu_bg">
        </div>
        <div class="product-container">
            <div class="content">
                <h1 class="hero-title">{{ $t('messages.productSearchList') }}</h1>
            </div>
            <div class="product-list" v-if="itemList">
                <div class="grid-container">
                    <div v-for="(item, index) in itemList" :key="index" class="grid-item">
                        <el-card
                            :body-style="{ padding: '0px', display: 'flex', 'flex-direction': 'column', 'align-items': 'center' }">
                            <el-image style="width: 50%; " :src="item.image_list[0].url"
                                :preview-src-list="[item.image_list[0].url]"></el-image>
                            <span class="title">{{ item.model }}</span>
                        </el-card>
                    </div>
                </div>

            </div>
            <div v-else>
                <el-empty description="没有搜索到相关产品"></el-empty>
            </div>
        </div>


    </div>
</template>

<script>
export default {
    name: "SearchList",
    props: {
        // product: {
        //   type: Object,
        //   required: true
        // }
    },
    data() {
        return {
            itemList: null,
            keyword: ''
        }
    },
    created() {
        this.keyword = this.$route.query.keyword;
        console.log('Keyword:', this.keyword);
        this.queryProduct();
    },

    async mounted() {
        // let res = await this.GetUrlsByHttp(this.GlobalData.productsUrl, 10)
        // console.log("resssss: ", res)
        // let tmp = res.concat(res).concat(res).concat(res).concat(res).concat(res)
        // this.itemInfo = tmp
        // console.log("itemInfo: ", this.itemInfo[0].image_list)
    },
    watch: {
        '$route.query.keyword': function (newKeyword) {
            this.keyword = newKeyword;
            console.log('Keyword updated:', this.keyword);
            this.queryProduct();
        }
    },
    methods: {
        async queryProduct() {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            try {
                let res = await this.GetUrlsByHttp(this.GlobalData.searchProductsUrl, this.keyword)
                console.log("resssss: ", res)
                let tmp = res.concat(res).concat(res).concat(res).concat(res).concat(res)
                this.itemList = tmp
                // console.log("itemInfo: ", this.itemList[0].image_list)
            } catch (error) {
                console.log(error)
            }finally {
                loading.close()
            }

        },
    }
}
</script>

<style scoped>
.menu_bg {
    height: 100px;
    width: 100%;
    position: relative;
    background-size: cover;
    background-color: #00579C;
}

.hero.simple:after {
    z-index: 1;
    content: "";
    background: rgba(0, 0, 0, 0) linear-gradient(180deg, #000000 0%, rgba(255, 255, 255, 0) 100%) 0% 0% no-repeat padding-box;
    width: 100%;
    height: 100%;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0.5;
}

@media (max-width: 1539px) {
    .hero.simple .content {
        padding: 24px 0 18px 48px;
    }
}

.content {
    /* position: absolute; */
    /* bottom: 0; */
    width: 100%;
    left: 0;
    background: rgba(0, 0, 0, 0) linear-gradient(90deg,
            var(--unnamed-color-008682) 0%,
            rgba(255, 255, 255, 0) 100%) 0% 0% no-repeat padding-box;
    background: rgba(0, 0, 0, 0) linear-gradient(90deg, #0077b4 0%, rgba(255, 255, 255, 0) 100%) 0% 0% no-repeat padding-box;
    padding: 24px 0 18px 73px;
}

.content .hero-title {
    margin: 0;
    padding: 0;
    color: #fff;
    font-size: 46px;
}

.product-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 10px;
}

.grid-container {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    /* 间隙 */
}

.grid-item {
    flex-basis: calc(50% - 50px);
    /* 计算每个项目的宽度，减去间隙的一半 */
    /* background-color: #ddd; */
    padding: 10px;
    text-align: center;
}

.title {
    font-size: 18px;
    margin-top: 10px;
    color: #00579c;
    margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/Products/SearchList.vue